import { Link } from 'react-router-dom';

import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Tooltip,
} from '@mui/material';
import {
  Settings as SettingsIcon,
  MeetingRoom as MeetingRoomIcon,
} from '@mui/icons-material';

import { FinancesIcon, DataIcon } from '../../assets/icons';
import colors from '../../assets/colors';

function ListItemLink(props) {
  return <ListItem button component={Link} {...props} />;
}

export const mainListItems = (
  <Box>
    <ListItemLink
      to="/dashboard/assesment"
      sx={{ marginTop: '1vh', marginBottom: '3vh' }}
    >
      <ListItemIcon>
        <FinancesIcon />
      </ListItemIcon>
      <ListItemText primary="Ocena zdolności" sx={{ color: colors.white }} />
    </ListItemLink>

    <ListItemLink
      to="/dashboard/loans"
      sx={{ marginTop: '3vh', marginBottom: '55vh' }}
    >
      <ListItemIcon>
        <DataIcon />
      </ListItemIcon>
      <ListItemText primary="Wniosek kredytowy" sx={{ color: colors.white }} />
    </ListItemLink>
  </Box>
);

export const logoutListItems = (
  <div>
    <Tooltip title="Już wkrótce!" placement="top-start">
      <span>
        <ListItemLink
          disabled
          to="/settings"
          sx={{ marginTop: '2vh', marginBottom: '2vh' }}
        >
          <ListItemIcon>
            <SettingsIcon sx={{ color: colors.white }} />
          </ListItemIcon>
          <ListItemText primary="Ustawienia" sx={{ color: colors.white }} />
        </ListItemLink>
      </span>
    </Tooltip>

    <ListItemLink to="/logout" sx={{ marginTop: '2vh', marginBottom: '2vh' }}>
      <ListItemIcon>
        <MeetingRoomIcon sx={{ color: colors.white }} />
      </ListItemIcon>
      <ListItemText primary="Wyloguj" sx={{ color: colors.white }} />
    </ListItemLink>
  </div>
);
